export const getScreenshotUrl = (deviceId: string, timestamp?: number) => {
  if (!deviceId) return '';
  const bucketUrl =
    'https://designage2-screenshots-staging.s3.eu-north-1.amazonaws.com';
  const now = timestamp || Date.now();
  return `${bucketUrl}/${deviceId.substring(0, 3)}/${deviceId}.jpeg?t=${now}`;
};
